








import Vue from 'vue'
import { AppModule } from '@/store/modules/app'
import { ErrorsModule } from '@/store/modules/error'
import StepComponent from "@/components/common/StepComponent.vue"

export default abstract class Configuration extends Vue {

    $refs!: {
        stepContent: StepComponent
    }

    get isShowList() {
        return AppModule.showMenu
    }
    
    get steps() {
        return AppModule.steps
    }

    get activeComponent() {
        return AppModule.activeStepComponent
    }

    get isOptional() {
        return AppModule.stepOptional
    }

    get currentStepIndex() {
        return AppModule.currentStepIndex
    }

    get numberOfSteps() {
        return AppModule.steps.length
    }
    
    abstract onCancel(): void
    
    abstract onConfirm(): void

    onError(message:string) {
        let error = { key: 'configuration', message: message }
        ErrorsModule.SetError(error)
    }
    
    abstract stepActivated(index:number): void
    
    abstract goToMenu(): void

}
